<template>
    <div class="user-appraise-view" v-if="appraise">
        <div class="user-desc">
            <div class="user-title">
                <img :src="appraise.userImg">
                <span>{{appraise.name}}</span>
            </div>
            <div class="user-appraise">
                <span>心得</span>
                {{appraise.content}}
            </div>
        </div>
        <div class="user-show">
            <img :src="appraise.showImg">
        </div>

    </div>
</template>

<script>
    export default {
        name: 'userAppraiseView',
        props: ['appraise'],
    }
</script>

<style lang="scss">
    .user-appraise-view {
        width: 280px;
        height: 130px;
        background-color: #fff;
        margin-right: 10px;
        box-shadow: 0px 0px 8px 0px #d0d0d0;
        .user-desc {
            width: 150px;
            height: 100%;
            padding: 6px;
            box-sizing: border-box;
            float: left;
            .user-title {
                margin-bottom: 18px;
                img {
                    width: 26px;
                    height: 26px;
                    border-radius: 50%;
                    vertical-align: middle;
                    margin-right: 10px;
                }
                span {
                    font-size: 12px;
                    color: #7c7c7c;
                    vertical-align: middle;
                }
            }
            .user-appraise {
                font-size: 12px;
                color: #aaa;
                line-height: 18px;
                span {
                    width: 42px;
                    height: 12px;
                    border: 1px solid red;
                    color: red;
                    font-size: 12px;
                    line-height: 12px;
                    text-align: center;
                }
            }
        }
        .user-show {
            width: 130px;
            height: 100%;
            float: left;
            img {
                width: 100%;
                height: 100%;
            }
        }
    }
</style>